import { Controller } from '@hotwired/stimulus'

export default class ModifierRuleController extends Controller {
  static targets = [
    'required',
    'amount',
    'min'
  ]

  static classes = [
    'invalid',
    'valid'
  ]

  static values = {
    min: { type: Number, default: 0 },
    isValid: { type: Boolean, default: false }
  }

  modifierChanged ({ detail: { min, isValid } }) {
    this.minValue = min
    this.isValidValue = isValid
  }

  isValidValueChanged () {
    const [first, second] = this.isValidValue ? [this.invalidClass, this.validClass] : [this.validClass, this.invalidClass]

    if (this.hasRequiredTarget) {
      this.requiredTarget.classList.replace(first, second)
    }

    if (this.hasAmountTarget) {
      this.amountTarget.classList.replace(first, second)
    }
  }

  minValueChanged () {
    this.minTarget.textContent = this.minValue.toString()
  }
}
